import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { ProveedorAvisos } from './components/avisos';
import { App } from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // El panel muestra pedidos vivos: los datos envejecen rápido.
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ProveedorAvisos>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ProveedorAvisos>
    </QueryClientProvider>
  </StrictMode>,
);
